import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import LinearProgress from '@material-ui/core/LinearProgress'

const styles = theme => ({
  root: { flexGrow: 1 }
})

const Loading = (props) => {
  const { classes } = props
  return (
    <div className={classes.root}>
      <LinearProgress color="secondary" />
    </div>
  )
}

Loading.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Loading)
